import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IUserInventoryList } from 'src/app/state-management/states/aumye-dashboard.state';

@Component({
  selector: 'app-inventory-details-card',
  templateUrl: './inventory-details-card.component.html',
  styleUrl: './inventory-details-card.component.scss',
})
export class InventoryDetailsCardComponent {
  @Input() inventory: any[];
  @Output() showDetails = new EventEmitter<any>();
  clickedItem: IUserInventoryList | null;
  isClicked = false;
  onShowDetails(val: any) {
    this.showDetails.emit(val);
    if (!this.isClicked) {
      this.clickedItem = val;
    } else this.clickedItem = null;
    this.isClicked = !this.isClicked;
  }
}
